import { TruckSearchResult } from '../dtos/index';
import { TruckSearchTable } from '../views/index';

import { GET_CARRIER_BUSINESS_NAME } from '../../carrier/utils/get-carrier-business-name';
import { DATE_MDY } from '../../utils';

export const SEARCH_CARRIER_ONLY_TABLE = (
	truckSearchResult: TruckSearchResult[]
): Array<TruckSearchTable> => {
	let allCapacitySearchResults: TruckSearchTable[] = [];
	try {
		allCapacitySearchResults = truckSearchResult.map((response: TruckSearchResult) => {
			let truck = {} as TruckSearchTable;
			truck.businessName = GET_CARRIER_BUSINESS_NAME(
				response.carrier.businessName,
				response.carrier.doingBusinessAs
			);
			truck.oldCarrierId =
				response.carrier.carrierId != undefined && response.carrier.carrierId != null
					? response.carrier.carrierId
					: null;
			truck.carrierId = response.carrier.carrierHubId;
			truck.customerCarrier = response.carrier.customerCarrier;
			truck.firmDot = response.carrier.dot || null;
			truck.firmMc = response.carrier.mc || null;
			truck.customerCode = response.carrier.customerCode;

			truck.carrierHQ =
				(response.carrier.city != undefined && response.carrier.city != null
					? response.carrier.city + ', '
					: '') +
				(response.carrier.state != undefined && response.carrier.state != null
					? response.carrier.state
					: '');

			truck.isLane = false;

			truck.drivers = response.carrier.drivers;
			truck.carrierLastFmcsaUpdate = response.carrier.carrierLastFmcsaUpdate;
			truck.powerUnits = response.carrier.powerUnits;
			truck.phone = response.carrier.phone;
			truck.trailers = response.carrier.trailers;
			truck.cellPhone = response.carrier.cellPhone;
			truck.businessEmailAddress = response.carrier.businessEmailAddress;
			truck.representative1 = response.carrier.representative1;
			if (
				response.carrier.brokerExclusivity != undefined &&
				response.carrier.brokerExclusivity != null
			) {
				truck.brokerExclusivity = response.carrier.brokerExclusivity;
			} else {
				truck.brokerExclusivity = null;
			}

			truck.isTruckAndLane = false;
			truck.showAvailableDate = false;
			truck.searchId = truck.isLane ? response.truckLaneSearchId : response.truckSearchId;
			truck.notesCount = response.carrier.notesCount;
			truck.recentFeedbackDate = response.recentFeedbackDate;
			truck.laneIds = response.laneIds;
			truck.hazmat = response.carrier.hazmat;
			truck.hasTeams = response.carrier.hasTeams;
			truck.hasTeamsUpdatedOn = response.carrier.hasTeamsUpdatedOn;
			truck.active = response.carrier.active;
			truck.authorityGrantDate = DATE_MDY(response.carrier.authorityGrantDate);

			truck.carrierContactsCount = response.carrier.contactCount;
			truck.lanesCount = 0;
			truck.notesCount = 0;

			return truck;
		});
	} catch (error) {
		console.log('SEARCH_CARRIER_ONLY_TABLE error: ', error);
	}

	return allCapacitySearchResults;
};
